/* eslint camelcase: 0 */
import { Division } from '@/infrastructure/network/Monitaro/schema/models'
import { IDivisionProps, EmptyDivisionPropsFactory } from '@/entities/Division'

export const toDivisionProps = (props: Division | null | undefined): IDivisionProps => {
  if (!props) {
    return EmptyDivisionPropsFactory()
  }

  const { id, hospital_id, name, created_at, updated_at } = props

  return EmptyDivisionPropsFactory({
    id,
    hospitalId: hospital_id,
    name,
    createdAt: created_at,
    updatedAt: updated_at
  })
}
